import { Component, ElementRef, OnInit } from '@angular/core';
import { LoaformService } from './RestServices/loaform.service';
import { API_URL } from './RestServices/restcall.constants';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit{
  constructor(private elementRef:ElementRef,private serv:LoaformService){    
  }
  version:any;
  headers:any;
  imageUrl:string=API_URL+"logo/TCS_White_2024.svg";
  ngOnInit(): void {
    this.removeNg();
    this.getVersion();
  }
  removeNg():any{
    this.elementRef.nativeElement.removeAttribute("ng-version");
  }
  getVersion(){
    this.serv.getVersion().subscribe((data:any)=>{
      // console.log(data);
      this.version = data["version"];
      // console.log(data.headers.keys());

    })
  }
  title = 'Angular';
}
